import script from "./UploadBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadBox.vue?vue&type=script&setup=true&lang=ts"

import "./UploadBox.vue?vue&type=style&index=0&id=bda52398&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bda52398"]])

export default __exports__